/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 0f6c2412d6a98fc31cc13bedcb805d80 */

import { ConcreteRequest } from "relay-runtime";
export type useLogout_resetSessionQueryVariables = {};
export type useLogout_resetSessionQueryResponse = {
    readonly viewer: {
        readonly session: {
            readonly id: string;
            readonly token: string;
            readonly expiresAt: string;
        };
        readonly currentUser: {
            readonly customerNumber: string;
        } | null;
    };
};
export type useLogout_resetSessionQuery = {
    readonly response: useLogout_resetSessionQueryResponse;
    readonly variables: useLogout_resetSessionQueryVariables;
};



/*
query useLogout_resetSessionQuery {
  viewer {
    session {
      id
      token
      expiresAt
    }
    currentUser {
      customerNumber
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "session",
  "storageKey": null,
  "args": null,
  "concreteType": "Session",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "token",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "expiresAt",
      "args": null,
      "storageKey": null
    }
  ]
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "customerNumber",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "useLogout_resetSessionQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "useLogout_resetSessionQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v0/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "useLogout_resetSessionQuery",
    "id": null,
    "text": "query useLogout_resetSessionQuery {\n  viewer {\n    session {\n      id\n      token\n      expiresAt\n    }\n    currentUser {\n      customerNumber\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '25a0cdbce3b387b85c37c397258c57be';
export default node;
